import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'adspt-disallowed-optimization-title',
  templateUrl: 'disallowed-optimization-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class DisallowedOptimizationTitleComponent {}
